import React from 'react'
import work_info from './work_experience_data'
import './work_experience.css'

function card() {
  return (
    <div className="pt-7">
      {/* max-w-md */}
      {work_info.map((work_info, index) => (
        <div className="pb-px">
          <div className="-mt-16">
            <div class="py-5 px-8 bg-gray-900 shadow-lg rounded-lg my-16">
              {/* justify-center md: */}
              <div class="flex justify-end -mt-16">
                <div className="circle-img w-20 h-20 object-cover rounded-full border-1 border-transparent bg-transparent">
                  <img class="image-class" src={work_info.image} alt={work_info.alt} />
                </div>
              </div>
              <div className="-mt-5">
                <h2 class="text-regal-blue lg:text-3xl md:text-3xl font-semibold">{work_info.company}</h2>
                <div className="header mt-2">
                  <h4 className="text-gray-400"><div className="role items-start">{work_info.role}</div><div className="years items-end">{work_info.period}</div></h4>
                </div>
                <p class="mt-2 text-gray-300">{work_info.desc}</p>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default card;

// https://tailwindcomponents.com/component/testimonial-card
